<template>
  <div>
    <!-- Header -->
    <AppHeader />

    <!-- Hero Section -->
    <section class="hero hero-eastern">
      <div class="container">
        <div class="hero-content fade-in-up">
          <h1>Всё об HSK</h1>
          <p>Международный экзамен по китайскому языку для определения уровня владения</p>
        </div>
      </div>
    </section>

    <!-- HSK Levels Section -->
    <UISection title="Уровни HSK">
      <template #default>
        <div class="features-grid">
          <div class="feature-card">
            <div class="feature-icon">
              <i class="fas fa-star"></i>
            </div>
            <h3>HSK 1</h3>
            <p>Базовый уровень. Понимание и использование простых фраз и предложений для удовлетворения конкретных потребностей в общении.</p>
            <ul class="hsk-features">
              <li>150 слов</li>
              <li>174 иероглифа</li>
              <li>Базовые фразы</li>
            </ul>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <i class="fas fa-star"></i>
            </div>
            <h3>HSK 2</h3>
            <p>Элементарный уровень. Способность общаться на простые и повседневные темы.</p>
            <ul class="hsk-features">
              <li>300 слов</li>
              <li>347 иероглифов</li>
              <li>Повседневное общение</li>
            </ul>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <i class="fas fa-star"></i>
            </div>
            <h3>HSK 3</h3>
            <p>Средний уровень. Способность общаться на китайском языке в повседневной, учебной и профессиональной сферах.</p>
            <ul class="hsk-features">
              <li>600 слов</li>
              <li>617 иероглифов</li>
              <li>Работа и учеба</li>
            </ul>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <i class="fas fa-star"></i>
            </div>
            <h3>HSK 4</h3>
            <p>Средне-продвинутый уровень. Способность обсуждать широкий круг тем на китайском языке.</p>
            <ul class="hsk-features">
              <li>1200 слов</li>
              <li>1064 иероглифа</li>
              <li>Сложные темы</li>
            </ul>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <i class="fas fa-star"></i>
            </div>
            <h3>HSK 5</h3>
            <p>Продвинутый уровень. Способность читать китайские газеты и журналы, понимать китайские фильмы и телепередачи.</p>
            <ul class="hsk-features">
              <li>2500 слов</li>
              <li>1685 иероглифов</li>
              <li>СМИ и культура</li>
            </ul>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <i class="fas fa-star"></i>
            </div>
            <h3>HSK 6</h3>
            <p>Высший уровень. Легко понимать устную и письменную информацию на китайском языке.</p>
            <ul class="hsk-features">
              <li>5000+ слов</li>
              <li>2663 иероглифа</li>
              <li>Профессиональное владение</li>
            </ul>
          </div>
        </div>
      </template>
    </UISection>

    <!-- Preparation Section -->
    <UISection title="Подготовка к HSK" :narrow="false">
      <template #default>
        <div class="preparation-content">
          <div class="preparation-text">
            <h3>Как мы готовим к экзамену</h3>
            <ul class="preparation-list">
              <li><i class="fas fa-check"></i> Изучение лексики по уровням</li>
              <li><i class="fas fa-check"></i> Практика аудирования</li>
              <li><i class="fas fa-check"></i> Тренировка письменной части</li>
              <li><i class="fas fa-check"></i> Пробные экзамены</li>
              <li><i class="fas fa-check"></i> Индивидуальный подход</li>
            </ul>
          </div>
          <div class="preparation-stats">
            <div class="stat-item">
              <div class="stat-number">95%</div>
              <div class="stat-label">Студентов сдают с первого раза</div>
            </div>
            <div class="stat-item">
              <div class="stat-number">4.8</div>
              <div class="stat-label">Средний балл наших студентов</div>
            </div>
          </div>
        </div>
      </template>
    </UISection>

    <!-- CTA Section -->
    <section class="cta-section">
      <div class="container">
        <h2>Готовы начать подготовку к HSK?</h2>
        <p>Запишитесь на бесплатный пробный урок и определите свой уровень</p>
        <UIButton to="/contacts#contact-methods">Записаться на урок</UIButton>
      </div>
    </section>

    <!-- Footer -->
    <UIFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import UIButton from '@/components/ui/UIButton.vue'
import UISection from '@/components/ui/UISection.vue'
import UIFooter from '@/components/ui/UIFooter.vue'

export default {
  name: 'HSKPage',
  components: {
    AppHeader,
    UIButton,
    UISection,
    UIFooter
  },
  mounted() {
    // Smooth scrolling for navigation links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });

    // Add animation on scroll
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in-up');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.feature-card, .preparation-content').forEach(el => {
      observer.observe(el);
    });
  }
}
</script>

<style scoped>
.nav-menu a.active {
  color: #e74c3c;
}

.hsk-features {
  list-style: none;
  padding: 0;
  margin-top: 1rem;
}

.hsk-features li {
  padding: 0.5rem 0;
  border-bottom: 1px solid #e2e8f0;
  color: #718096;
}

.hsk-features li:last-child {
  border-bottom: none;
}

.preparation-content {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 3rem;
  align-items: center;
  margin-top: 2rem;
}

.preparation-list {
  list-style: none;
  padding: 0;
}

.preparation-list li {
  padding: 0.75rem 0;
  display: flex;
  align-items: center;
  gap: 1rem;
  color: #4a5568;
}

.preparation-list i {
  color: #48bb78;
  font-size: 1.2rem;
}

.preparation-stats {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.stat-item {
  text-align: center;
  padding: 2rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 15px;
}

.stat-number {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.stat-label {
  font-size: 1rem;
  opacity: 0.9;
}

@media (max-width: 768px) {
  .preparation-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  .preparation-stats {
    flex-direction: row;
    gap: 1rem;
  }
  
  .stat-item {
    padding: 1.5rem;
  }
  
  .stat-number {
    font-size: 2rem;
  }
}
</style>
